var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"checkbox",on:{"click":function($event){return _vm.clickBox()}}},[_c('img',{attrs:{"src":require('@/assets/'+ (_vm.check ? 'checked-green.svg' : 'unchecked.svg')),"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }